import React from 'react';
import PropTypes from 'prop-types';
import { Cushion, MaxWidth, Space } from '@pitchero/react-ui';
import RosBottomBanner from '../../adverts/ros-bottom-banner';
import TopBannerVideoPlayerSwitch from '../../adverts/top-banner-video-player-switch';
import CLUB_PROP_TYPES from '../../../lib/prop-types/club';
import TeamListSection from './section';

const TeamList = ({ club, sections }) => {
  const { advertisingTier, sportId } = club;

  return (
    <Cushion all="medium" responsive={[{ maxWidth: 'tab', props: { horizontal: 'small' } }]}>
      <MaxWidth component="div" maxWidth={1366} center>
        <Cushion top="medium">
          <TopBannerVideoPlayerSwitch
            advertisingTier={advertisingTier}
            pageType="team.list"
            sportId={sportId}
          />
        </Cushion>

        {sections.map((section) => (
          <Space key={section.id} bottom="xlarge" component="div">
            <TeamListSection id={section.id} name={section.name} teams={section.teams} />
          </Space>
        ))}

        <Cushion vertical="medium">
          <RosBottomBanner />
        </Cushion>
      </MaxWidth>
    </Cushion>
  );
};

TeamList.propTypes = {
  club: CLUB_PROP_TYPES.isRequired,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      teams: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
          image: PropTypes.string.isRequired,
        }),
      ).isRequired,
    }),
  ).isRequired,
};

export default TeamList;
